import {
  SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION_SUBMISSION,
} from 'api/actionTypes';

import updateLocalApplicationSubmission from 'client/actions/HouseholdApplicationSubmission/updateLocalApplicationSubmission';

export default async function payApplicationSubmission({ state, apiClient }, payload) {
  const {
    source,
    applicationId,
    householdApplicationSubmissionId,
    listingId,
  } = payload;

  await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_PAY_APPLICATION_SUBMISSION,
    state: state,
    payload: {
      source,
      listingId,
      applicationId,
    },
    onSuccess({ stripeChargeId }) {
      if (householdApplicationSubmissionId) {
        updateLocalApplicationSubmission(
          { state },
          { householdApplicationSubmissionId, updates: { stripeChargeId } },
        );
      }
    },
    onError(error) {
      throw error;
    },
  });
}
